var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("br"),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button download right",
        on: {
          click: function ($event) {
            return _vm.onDownloadLogClick($event)
          },
        },
      },
      [_vm._v("Download event log")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }